import React from "react";

const FormPreviewModal = ({ fields, onClose }) => {
    console.log("Fields passed to preview:", fields); // Debugging

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                    maxHeight: "80%",
                    overflowY: "auto",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                }}
            >
                <h2>Form Preview</h2>
                <form>
                    {fields.map((field, index) => {
                        const labelText = (
                            <>
                                {field.name}
                                {field.required && <span style={{ color: "red" }}> *</span>}
                            </>
                        );

                        if (["text", "number", "input", "email", "phone", "date"].includes(field.type)) {
                            return (
                                <div key={index} className="form-group">
                                    <label>{labelText}</label>
                                    <input
                                        type={field.type === "phone" ? "tel" : field.type}
                                        className="form-control"
                                        required={field.required}
                                    />
                                </div>
                            );
                        } else if (field.type === "select" && field.options) {
                            return (
                                <div key={index} className="form-group">
                                    <label>{labelText}</label>
                                    <select className="form-control" required={field.required}>
                                        {field.options.map((option, idx) => {
                                            // Handle both legacy (string) and new (object) formats
                                            // Also handle null/undefined options gracefully
                                            if (!option) {
                                                return null; // Skip null/undefined options
                                            }
                                            
                                            const optionValue = typeof option === 'string' ? option : (option.value || '');
                                            const optionText = typeof option === 'string' ? option : (option.name || '');
                                            const isDisabled = typeof optionText === 'string' && optionText.startsWith("Please select");
                                            
                                            return (
                                                <option 
                                                    key={idx} 
                                                    value={optionValue}
                                                    disabled={isDisabled}
                                                    selected={idx === 0}
                                                >
                                                    {optionText}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            );
                        } else if (field.type === "radio" && field.options) {
                            return (
                                <div key={index} className="form-group">
                                    <label>{labelText}</label>
                                    <div>
                                        {field.options.map((option, idx) => {
                                            // Handle both legacy (string) and new (object) formats
                                            // Also handle null/undefined options gracefully
                                            if (!option) {
                                                return null; // Skip null/undefined options
                                            }
                                            
                                            const optionValue = typeof option === 'string' ? option : (option.value || '');
                                            const optionText = typeof option === 'string' ? option : (option.name || '');
                                            
                                            return (
                                                <div key={idx} className="form-check">
                                                    <input
                                                        type="radio"
                                                        id={`${field.name}-${idx}`}
                                                        name={field.name}
                                                        value={optionValue}
                                                        required={field.required}
                                                        className="form-check-input"
                                                    />
                                                    <label
                                                        htmlFor={`${field.name}-${idx}`}
                                                        className="form-check-label"
                                                    >
                                                        {optionText}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        } else if (field.type === "display_text") {
                            return (
                                <div key={index} className="form-group">
                                    <div style={{
                                        backgroundColor: "#e3f2fd",
                                        padding: "12px",
                                        borderRadius: "8px",
                                        border: "1px solid #bbdefb",
                                        fontSize: "14px",
                                        color: "#333"
                                    }}>
                                        {field.text || "Display text content"}
                                    </div>
                                </div>
                            );
                        }
                        return '<p>No fields added to the form yet.</p>';
                    })}
                </form>
                <div style={{ marginTop: "20px", textAlign: "right" }}>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FormPreviewModal;